export const AFTER_OFFLINE_REPORTING_VITALS_INFO =
  'after-offline-reporting-vitals-info'
